module.exports = __webpack_public_path__ + "img/ispy.d9cb8fed.png";